// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__PlrxH","title":"AfterBackImages_title__1pyvB","images":"AfterBackImages_images__f1_zz"};